import { DeviceUiSettings8021xBehaviorPlugin, Sh8021xMethod } from '@shure/device-ui/settings/8021x/data-access';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceBehaviorPlugin } from '@shure/shared/angular/device-behavior/core';

export class Imxtp10DeviceUiDeviceBehaviorPlugin implements DeviceBehaviorPlugin, DeviceUiSettings8021xBehaviorPlugin {
	public readonly models: DeviceModel[] = [DeviceModel.IMXTP10];

	public getAllowed8021xEapMethods(_model: DeviceModel): ReadonlyArray<Sh8021xMethod> {
		return [
			Sh8021xMethod.None,
			Sh8021xMethod.PeapGtc,
			Sh8021xMethod.Tls,
			Sh8021xMethod.TtlsGtc,
			Sh8021xMethod.TtlsPap,
			Sh8021xMethod.PasswordOnly,
			Sh8021xMethod.Md5
		];
	}

	public supportsEapTlsAnonymousId(_model: DeviceModel): boolean {
		return false;
	}

	public isRebootNeededToApply8021xConfig(_model: DeviceModel, enabledStateAfterReboot?: boolean): boolean {
		return enabledStateAfterReboot === false;
	}
}
